import React, { FC, ForwardedRef, forwardRef, InputHTMLAttributes } from 'react';

import * as S from './styles';

export interface IDefaultInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'placeholder'> {
  label: string;
}

const InputDefault: FC<IDefaultInputProps> = forwardRef(
  ({ label, ...props }, ref: ForwardedRef<HTMLInputElement>) => (
    <S.Container>
      <S.StyledInput
        {...props}
        ref={ref}
        placeholder=" "
      ></S.StyledInput>
      <S.Label>{label}</S.Label>
    </S.Container>
  ),
);

InputDefault.displayName = 'InputDefault';

export default InputDefault;
